export default __webpack_public_path__ + "static/arjun-f7f5fbb125dab06df1cdb9cfd4c8bb38.png";